<ax-image-edit
  [form]="form"
  [name]="name"
  [hint]="hint"
  [required]="required"
  [acceptTypes]="acceptTypes"
  [maxFileSize]="maxFileSize"
  [uploadLink]="uploadLink"
  [demo]="demo"
  [preview]="true"
  [showIcon]="showIcon"
  [readonly]="readonly"
  previewUrl="/staticFiles/agreementFiles/"
></ax-image-edit>
